<template>
  <!--https://kholinlabs.com/creating-a-landing-page-in-django-->

  <!-- Page Content -->
  <div class="whole-page">
    <AIChatFloat :colorTheme="colorTheme" />
    <div class="navbar-div">
      <NavbarComponent
        :colorTheme="colorTheme"
        :user="user"
        analysis="TUTORIALS"
        :selectedNavLink="selectedNavLink"
        @eventOnUserSelectNavLink="eventOnClientSelect"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>
    <div class="row f-row">
      <div
        class="col col-12"
        style="border-bottom: 2px solid var(--darkbackground)"
      >
        <NavbarCustom
          :isLight="true"
          :linkList="[
            'User Manual (ESP)',
            'Apps Highlights',
            'Technical Analysis (ESP)',
          ]"
          :selectedNavLink="selectedTutorial"
          @eventOnClientSelect="eventOnClientTutorial"
        />
      </div>
    </div>
    <!-- Tab 1 selected / Manual -->
    <PDFDisplay
      v-if="selectedTutorial === 0"
      :pdfButtons="manualButtons"
      :pdfName="'/files/manualQuanspire.pdf'"
    ></PDFDisplay>
    <!-- Tab 2 selected / Apps -->
    <div
      class="row f-row mt-1 no_nav_tut_height justify-content-center"
      v-else-if="selectedTutorial === 1"
    >
      <div class="col col-10 no_nav_tut_height">
        <table class="table table-borderless table-tutorial table-sm">
          <thead>
            <tr>
              <th style="width: 220px" colspan="2">APP</th>
              <!--                            <th style="width: 160px">APP</th>-->
              <th>DESCRIPTION</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(port, index) in tableValues" :key="index">
              <td style="width: 60px" class="text-center">
                <img
                  class="align-self-center"
                  :src="port.img"
                  height="50px"
                  alt=""
                />
              </td>
              <td style="width: 160px">
                {{ port.app }}
              </td>
              <td style="color: var(--textinactive)">
                {{ port.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Tab 3 selected / Technical Analysis -->
    <PDFDisplay
      v-if="selectedTutorial === 2"
      :pdfButtons="techAnButtons"
      :pdfName="'/files/analisisTecnico.pdf'"
    ></PDFDisplay>
  </div>
</template>

<script>
import AIChatFloat from "@/components/ai/AIChatFloat.vue";
import NavbarComponent from "../components/Navbar.vue";
import NavbarCustom from "@/components/NavbarCustom";
import PDFDisplay from "@/components/tutorials/PDFDisplay";
import { getDefaultAnalyticsPreferences } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import { colorThemeChange, colorThemeVuex } from "@/_core/_helpers/_helpers";
import { saveUserPreferences } from "@/_core/data/SaveToDB";

export default {
  name: "education",
  components: {
    AIChatFloat,
    NavbarComponent,
    NavbarCustom,
    PDFDisplay,
  },
  data() {
    return {
      analyticsPreferences: {},
      colorTheme: true, // true = dark, else light
      commodityImg: require("@/assets/images/commodities.svg"),
      currencyImg: require("@/assets/images/currency.png"),
      hoverCommodities: false,
      hoverCurrency: false,
      hoverEducation: false,
      hoverLogo: false,
      hoverMarkets: false,
      hoverMulti: false,
      hoverMydata: false,
      hoverStrategy: false,
      linkList: ["Platform", "Terminology", "Courses"],
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      manualButtons: [],
      marketsImg: require("@/assets/images/globe.svg"),
      multiImg: require("@/assets/images/multiAsset.png"),
      myDataImg: require("@/assets/images/server.png"),
      optimizerImg: require("@/assets/images/strategy.png"),
      overviewImg: require("@/assets/images/overview.png"),
      selectedNavLink: 0,
      selectedTutorial: 0,
      tableValues: [],
      techAnButtons: [],
      user: [],
    };
  },
  created() {
    this.analyticsPreferences = getDefaultAnalyticsPreferences(this)["choices"];
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.colorTheme = this.analyticsPreferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }
    Object.assign(this, {
      manualButtons: [
        {
          page: 1,
          endPage: 3,
          name: "Presentacion",
        },
        {
          page: 4,
          endPage: 4,
          name: "Índice",
        },
        {
          page: 5,
          endPage: 8,
          name: "Configuracion",
        },
        {
          page: 9,
          endPage: 18,
          name: "Overview",
        },
        {
          page: 19,
          endPage: 27,
          name: "Data Model",
        },
        {
          page: 28,
          endPage: 42,
          name: "Analytics",
        },
        {
          page: 43,
          endPage: 47,
          name: "Advanced",
        },
        {
          page: 48,
          endPage: 66,
          name: "Markets",
        },
        {
          page: 67,
          endPage: 78,
          name: "Optimizer",
        },
      ],
    });
    Object.assign(this, {
      techAnButtons: [
        {
          page: 1,
          endPage: 2,
          name: "Presentación",
        },
        {
          page: 2,
          endPage: 15,
          name: "Introducción",
        },
        {
          page: 15,
          endPage: 27,
          name: "Fundamentos",
        },
        {
          page: 27,
          endPage: 46,
          name: "Velas",
        },
        {
          page: 46,
          endPage: 62,
          name: "Soporte | Resistencia",
        },
        {
          page: 62,
          endPage: 89,
          name: "Índices | Patrones",
        },
      ],
    });
    document.title = "Tutorials | Quanspire";
  },
  mounted() {
    this.tableValues = [
      {
        app: "Overview",
        img: this.overviewImg,
        description:
          "Our goal is to provide You with an unique analytical platform to make better hedging decisions:\n" +
          "                    - Manage and access your data: cash flows, balance position, purchases or sales and hedging strategies: My Data.\n" +
          "                    - Determine the best course of action to positively impact Your Company's risk: Multi-Asset, Currency and Commodities.\n" +
          "                    - Build a strong perspective of market conditions and trends: Markets.\n" +
          "                    - Optimize hedging structures with powerful mathematical algorithms: Optimizer.",
      },
      {
        app: "Data Model",
        img: this.myDataImg,
        description:
          "Define each portfolio's hedging program.\n" +
          "                    Upload/download all your exposures and hedges: accounts payable/receivable, projected cash flows,\n" +
          "                    assets and liabilities for currencies and purchases and sales for commodities.",
      },
      // {
      //   app: "Multi-asset",
      //   img: this.multiImg,
      //   description:
      //     "Visualize the overall risk of all your traded commodities and currencies.\n" +
      //     "                    Get insights on how the asset correlations of the different portfolios affect Your risk and provide the best hedging cost opportunities."
      // },
      {
        app: "Analytics | Currencies",
        img: this.currencyImg,
        description:
          "Analyze each portfolio´s currency risk and expected outcomes.\n" +
          "                    Consolidate all balance and cash flow risks; group them according to their expiration dates.\n" +
          "                    Evaluate the implementation of your hedging program. Perform “What-If” Analysis, measure risk based on simulations\n" +
          "                    with real-time market data and review the performance of the executed hedging program.",
      },
      {
        app: "Analytics | Commodity",
        img: this.commodityImg,
        description:
          "Analyze each portfolio portfolio's commodity risk and expected outcomes.\n" +
          "                    Consolidate all sales or purchases; group them according to their expiration dates.\n" +
          "                    Evaluate the implementation of your hedging program. Perform “What-If” Analysis, measure risk based on simulations\n" +
          "                    with real-time market data and review the performance of the executed hedging decisions.",
      },
      {
        app: "Markets",
        img: this.marketsImg,
        description:
          "Analyze current market conditions based on powerful quantitative analysis and reports.\n" +
          "                    Build-in analytical tools powered by machine learning will provide you with unique insights on market trends and relevant correlations.",
      },
      {
        app: "Optimizer",
        img: this.optimizerImg,
        description:
          "Use all the insights you gained in the preceding steps to make better hedging decisions.\n" +
          "                    Instantly design hedging structures and get indicative quotes based on real market data.\n" +
          "                    Analyze and understand the outcomes based on simulations and optimization algorithms.",
      },
    ];
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.analyticsPreferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    eventOnClientSelect(idx) {
      this.selectedNavLink = idx;
    },
    eventOnClientTutorial(idx) {
      this.selectedTutorial = idx;
    },
    onMouseOver() {
      this.logo = this.logo_blue;
      this.hoverLogo = true;
    },
    onMouseLeave() {
      this.logo = this.logo_white;
      this.hoverLogo = false;
    },
  },
};
</script>
